import i18n from "i18next";
import { initReactI18next } from "react-i18next";

type Translations = Record<string, unknown>;

interface I18nConfig {
  locale: string;
  translations: Translations;
}

export function initI18n(config: I18nConfig): void {
  const { locale, translations } = config;

  i18n.use(initReactI18next).init({
    resources: {
      [locale]: {
        translation: translations,
      },
    },
    lng: locale,
    fallbackLng: "es-AR",
    interpolation: {
      escapeValue: false,
      prefix: "%{",
      suffix: "}",
    },
    returnNull: false,
    returnEmptyString: false,
  });
}

export default i18n;
